interface ErrorResponse {
    response?: {
        data?: {
            Error?: string;
            msg?: string;

        };
    };
    msg?: string;
}

export function getErrorMessageResendCode(error: ErrorResponse) {
    const errorMessageFromResponse = error.response?.data?.msg;

    if (errorMessageFromResponse) {
        return errorMessageFromResponse;
    }

    const errorMessage =
        error?.response?.data?.Error ||
        'Erro ao reenviar o código, tente novamente mais tarde.';

    return errorMessage;
}
